const formRows = [
  {
    span: 24,
    label: '标题',
    component: 'AInput',
    placeholder: '请输入公告标题',
    prop: 'title',
    allowClear: true
  },
  // {
  //   span: 10,
  //   label: '发布日期',
  //   component: 'ADate',
  //   placeholder: '请选择发布日期',
  //   prop: 'publishTime'
  // },
  {
    span: 24,
    label: '首图',
    component: 'AUpload',
    prop: 'picPath'
  },
  {
    span: 24,
    label: '附件',
    component: 'AUploadMultiple',
    prop: 'annexIds'
  }
]
// var reg = new RegExp('^[1-9](\\d{0,7})((\\.\\d{1,2})?)$') // 校验数字
const formRules = {
  title: [
    { required: true, message: '标题不能为空', trigger: 'blur' },
    { min: 1, max: 100, message: '输入的字数不能超过100个', trigger: 'blur' }
  ],
  picPath: [{ required: true, message: '首图不能为空', trigger: ['blur'] }],
  // publishTime: [
  //   { required: true, message: '发布日期不能为空', trigger: ['blur'] }
  // ],
  annexIds: [{ required: true, message: '附件不能为空', trigger: ['blur'] }]
}

const formInfo = [
  { label: '公告标题', value: '-', key: 'title' },
  // { label: '发布日期', value: '-', key: 'publishTime' },
  { label: '首图', value: '-', key: 'picture', isVHtml: true },
  { label: '附件', value: '-', key: 'annex', isVHtml: true }
]

module.exports = {
  formRows,
  formRules,
  formInfo
}
